export default Object.freeze({
  RENUNCIA: 1,
  DECESO: 2,
  FALTA_DE_DISPONIBILIDAD: 3,
  ANADIR_OTRO_ESPECIALISTA: 4,
  ENFERMEDAD: 5,
  MATERNIDAD_PATERNIDAD: 6,
  REMOCION_DE_PATRIA_POTESTAD: 7,
  CAMBIO_DE_CUSTODIA: 8,
  RECLUSION: 9,
  OTRO: 10,
});
